var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3169_28294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.30579L3.44055 13.3622C3.44055 13.3721 3.43805 13.3868 3.43305 13.4068C3.42814 13.4266 3.42554 13.441 3.42554 13.4512V20.5965C3.42554 20.8545 3.51986 21.0781 3.70845 21.2664C3.89699 21.4548 4.12025 21.5496 4.37829 21.5496H10.0944V15.8331H13.9057V21.5498H19.6218C19.8798 21.5498 20.1033 21.4552 20.2916 21.2664C20.4802 21.0783 20.5748 20.8546 20.5748 20.5965V13.4512C20.5748 13.4116 20.5694 13.3816 20.5598 13.3622L12 6.30579Z",
    fill: "#050033",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8344 11.7544L20.5745 9.0451V2.97143C20.5745 2.83258 20.5299 2.71839 20.4403 2.62902C20.3515 2.53976 20.2373 2.49513 20.0981 2.49513H17.24C17.101 2.49513 16.9869 2.53976 16.8974 2.62902C16.8082 2.71839 16.7636 2.83263 16.7636 2.97143V5.87424L13.1315 2.83732C12.8142 2.57928 12.4371 2.45029 12.0003 2.45029C11.5637 2.45029 11.1865 2.57928 10.869 2.83732L0.165418 11.7544C0.0661949 11.8337 0.0118127 11.9404 0.00169755 12.0744C-0.00836549 12.2083 0.0263077 12.3252 0.105821 12.4244L1.02875 13.526C1.10827 13.6153 1.21234 13.6699 1.34139 13.6898C1.46053 13.6998 1.57967 13.665 1.69881 13.5856L12 4.99594L22.3013 13.5856C22.3809 13.6548 22.4849 13.6894 22.614 13.6894H22.6587C22.7876 13.6698 22.8914 13.6148 22.9713 13.5258L23.8944 12.4243C23.9737 12.3249 24.0085 12.2082 23.9982 12.0741C23.988 11.9405 23.9334 11.8338 23.8344 11.7544Z",
    fill: "#050033",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3169_28294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.957aa433e8d268e8fee5de4793d70467.svg";
export { ForwardRef as ReactComponent };